<script setup lang="ts">
import { computed, defineProps } from 'vue'
import { PersonalAccountPage } from '../../utilities/account/useAccountNavigationPersonal'
import { LegalAccountPage } from '../../utilities/account/useAccountNavigationLegal'
import { getIconForPage } from '../../utilities/helpers'
import { NavigationItemParent } from '../../typings'

const props = defineProps<{
    page: PersonalAccountPage | LegalAccountPage
    navigationItems: NavigationItemParent[]
}>()

const pageIcon = computed(() => {
    return getIconForPage(props.navigationItems, props.page)
})
</script>
<template>
    <div v-bind="$attrs">
        <Component :is="pageIcon" />
    </div>
</template>

<style scoped></style>
